
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
  font-family: var(--ff-display);
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* unset browser defaults for headings and p */
:host:is(h1,h2,h3,h4,h5,h6,p),
h1,h2,h3,h4,h5,h6 {
  all: unset;
}
/* Image reset */
img {
  max-width: 100%;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.sr-only,
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.accordion-button {
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  border-width: 0px;
  padding-top: 0;
  padding-bottom: 0;
  padding-left: var(--spacing-08);
  padding-right: 0;
}

.accordion-button.mobile {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
  padding-left: var(--spacing-04) !important;
  padding-right: 0 !important;
  font-size: var(--fs-base) !important;
  line-height: var(--lh-base) !important;
  line-height: 1.25rem !important;
}

.accordion-button.active {
  background-color: var(--outline-soft-black);
  color: var(--outline-white);
}

.accordion-button.inactive {
  background-color: var(--outline-white);
  color: var(--outline-soft-black);
}

.accordion-button.clean {
  border-bottom-width: 1px;
  border-style: solid;
  border-color: var(--outline-gray-300);
  padding-left: 0;
}

.accordion-button.clean.active {
  background-color: var(--outline-white) !important;
  color: var(--outline-soft-black) !important;
}

.accordion-button.clean.inactive {
  color: var(--outline-soft-black);
}

.accordion-content {
  padding-left: var(--spacing-08);
  padding-right: var(--spacing-08);
  padding-top: var(--spacing-04);
  padding-bottom: var(--spacing-04);
}

.accordion-content.mobile {
  padding-left: var(--spacing-04);
  padding-right: var(--spacing-04);
}

.clean .accordion-content {
  padding-left: 0;
  padding-right: 0;
}

.accordion-label {
  text-align: left;
  max-width:75%;
}

::slotted(outline-heading){
  margin:1rem 0;
}

.accordion-heading {
  margin: 0;
  display: flex;
}

.accordion-icon {
  display: flex;
  height: 100%;
  width: var(--spacing-20);
  align-items: center;
  justify-content: center;
}

.accordion-icon.clean {
  background-color: var(--outline-white) !important;
  color: var(--outline-soft-black) !important;
}

.accordion-icon.active {
  background-color: var(--outline-soft-black);
  color: var(--outline-white);
}

.accordion-icon.inactive {
  background-color: var(--outline-gray-600);
  color: var(--outline-white);
}

.accordion-panel {
  margin-bottom: var(--spacing-06);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border-radius: 0.375rem;
  border-width: 1px;
  border-style: solid;
  border-color: var(--outline-soft-black);
}

.accordion-panel.clean {
  border-width: 0px;
}
`;